const RumbleSvg = ({
  width = 19,
  height = 20,
  viewBox = '0 0 19 20',
  fill = 'white',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  fill?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M11.1392 11.2882C11.8112 10.743 11.9139 9.75645 11.3688 9.08445C11.3004 9.00014 11.2235 8.92318 11.1392 8.85478C10.0393 7.94119 8.8327 7.1644 7.54574 6.54145C6.65741 6.11645 5.66574 6.70812 5.52399 7.71978C5.30582 9.23831 5.26666 10.7772 5.40733 12.3049C5.50399 13.3299 6.48399 13.9415 7.38399 13.5482C8.73106 12.9688 9.9941 12.2109 11.1392 11.2949V11.2882ZM16.916 6.78803C18.6106 8.6447 18.6157 11.4855 16.9277 13.3483C14.0174 16.5605 10.2152 18.8317 6.00733 19.8717C3.76999 20.4311 1.49333 19.11 0.868828 16.8899C-0.401172 12.5564 -0.214506 7.65637 1.01049 3.30287C1.65383 1.0162 3.80391 -0.418884 6.01899 0.109532C10.1225 1.08787 13.9726 3.6062 16.916 6.78628V6.78803Z"
        fill={fill}
      />
    </svg>
  );
};

export default RumbleSvg;
